import { ReactNode, createContext, useContext } from 'react';

import { ChatEventFragment } from '@spotify/confidence-graphql';

import { type InlineBlocksIndex } from '../AssistantMessage/inlineBlocks';

type ChatContextValue = {
  chatName: string;
  chatEvents: ChatEventFragment[];
  inlineBlocks: InlineBlocksIndex;
  isStreaming?: boolean;
};

const ChatContext = createContext<ChatContextValue | null>(null);

export const ChatContextProvider = ({
  value,
  children,
}: {
  value: ChatContextValue;
  children: ReactNode;
}) => <ChatContext.Provider value={value}>{children}</ChatContext.Provider>;

export const useChatContext = () => useContext(ChatContext);
